import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { TAX_MAILBOX } from '../../../../../../../utility/SourceAPI'

export const getTaxMailBoxes = createAsyncThunk('appTaxMailbox/getTaxMailboxes', async () => {
    const response = await axios.get(TAX_MAILBOX)
    return {
        data: response.data
    }
})

export const createTaxMailBox = createAsyncThunk('appTaxMailbox/createTaxMailBox', async (taxMailBoxData, { dispatch }) => {
    const response = await axios.post(TAX_MAILBOX, taxMailBoxData)
    await dispatch(getTaxMailBoxes())
    return response.data
})

export const updateTaxMailBox = createAsyncThunk('appTaxMailbox/updateTaxMailBox', async (data, { dispatch }) => {
    const response = await axios.put(`${TAX_MAILBOX}${data.id}`, data)
    await dispatch(getTaxMailBoxes())
    return response.data
})

// Deprecated - No se requiere marcar el buzón como revisado, se elimina esta funcionalidad para simplificar el proceso y evitar confusiones. Si es necesario implementar un sistema de seguimiento, se considerará una solución más robusta en el futuro.
// export const confirmTaxMailBox = createAsyncThunk('appTaxMailbox/confirmTaxMailBox', async (data, { dispatch }) => {
//     const response = await axios.put(`${TAX_MAILBOX}update-status/${data.id}?tb_status=checked`, data)
//     await dispatch(getTaxMailBoxes())
//     return response.data
// })

export const taxMailBoxSlice = createSlice({
    name: 'appTaxMailbox',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTaxMailBoxes.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default taxMailBoxSlice.reducer